import React from 'react'
import { useSelector } from 'react-redux';
const Confdata = window['runConfig'];
const baseURL = Confdata.apiUrl
// const apiKey = Confdata.apiKey
// const serviceKey =  Confdata.serviceKey

function RunScript({ value }) {

    const store = useSelector(state => state);

    React.useEffect(() => {
        // Define the script content
        if (value === 1 || store.globalreducer.theWidgetSession) {
            const scriptContent1 = `
        var __acstoolbar = {};
        __acstoolbar.servicekey = "avhantest29";
        __acstoolbar.apikey = "e763f560e120b316ea7ea4f2de646d780e64457c160c";
        __acstoolbar.tracelevel = '1';
        __acstoolbar.language = 'english';
        __acstoolbar.target = ${baseURL};
        __acstoolbar.serverpath = ${baseURL};
        __acstoolbar.applicationpath = ${baseURL};
        __acstoolbar.visible = 'false';
        __acstoolbar.visibility = 'show';
        __acstoolbar.display = "resize";
        __acstoolbar.widgeticon = "show";
        __acstoolbar.theme = 'theme_orange2';

        (function () {
            var joinSC = document.createElement('script');
            joinSC.type = 'text/javascript';
            joinSC.src = __acstoolbar.target + '/jodowidgetapi/js/initfunctions.js';
            joinSC.onload = validateKey;
            var joinScript = document.getElementsByTagName('script')[0];
            joinScript.parentNode.insertBefore(joinSC, joinScript);
        })();

        function validateKey() {
            var jodoInit = new jodoworld.initfunctions();
            jodoInit.initService();
        }
    `;
            const scriptContent2 = `
        var __acstoolbar = {};
        __acstoolbar.servicekey = "avhantest29";
        __acstoolbar.apikey =  "e763f560e120b316ea7ea4f2de646d780e64457c160c";
        __acstoolbar.tracelevel = '1';
        __acstoolbar.language = 'english';
        __acstoolbar.target =  ${baseURL};
        __acstoolbar.serverpath = ${baseURL};
        __acstoolbar.applicationpath =  ${baseURL};
        __acstoolbar.visible = 'false';
        __acstoolbar.visibility = 'hide';
        __acstoolbar.display = "resize";
        __acstoolbar.widgeticon = "hide";
        __acstoolbar.theme = 'theme_orange2';

        (function () {
            var joinSC = document.createElement('script');
            joinSC.type = 'text/javascript';
            joinSC.src = __acstoolbar.target + '/jodowidgetapi/js/initfunctions.js';
            joinSC.onload = validateKey;
            var joinScript = document.getElementsByTagName('script')[0];
            joinScript.parentNode.insertBefore(joinSC, joinScript);
        })();

        function validateKey() {
            var jodoInit = new jodoworld.initfunctions();
            jodoInit.initService();
          
                jodoInit.EndSession()
            
        }
    `;
            // const scriptContent = store.globalreducer.theWidgetSession ? scriptContent2 : scriptContent1

            // // Create a new script element
            // const script = document.createElement('script');
            // script.type = 'text/javascript';
            // script.innerHTML = scriptContent;

            // // Append the script to the body
            // document.body.appendChild(script);

            // // Cleanup function to remove the script when the component is unmounted
            // return () => {
            //     document.body.removeChild(script);
            // };

        }


    }, [store.globalreducer.theWidgetSession]);




    return (
        <></>
    )
}

export default RunScript